(function ( $ ) {

    $(document).on('click', '.yna_special_select', function () {
        if ($('.yna_special_select.open').length > 0) {
            $('.yna_special_select.open').not($(this)).removeClass('open');
        }
        $(this).toggleClass('open');
    });

    $(document).on('click', 'body', function (e) {
        if (! $(e.target).parents('.yna_special_select').length) {
            if ($('.yna_special_select.open').length > 0) {
                $('.yna_special_select.open').removeClass('open');
            }
        }
    });

    $.fn.specialSelect = function() {
        const elem = $(this);
        const place_holder = elem.data('placeholder');
        const specialSelectElem = elem.next('.yna_special_select');

        return {
            init(options) {
                const multiple_template = $(`
                <div class="yna_special_select">
                    <div class="select_parent"></div>
                    <ul class="items"></ul>
                </div>`);

                elem.hide();

                multiple_template.insertAfter(elem);

                if (place_holder && place_holder.length) {
                    multiple_template.find('.select_parent').html(place_holder);
                }

                elem.find('option').each(function (index, item) {
                    const value = $(item).val();
                    const html = $(item).html();

                    const data = $(item).data();
                    const dataKeys = Object.keys(data);
                    let dataHtml = '';

                    dataKeys.forEach((key) => {
                        dataHtml += `data-${key}="${data[key]}" `
                    });

                    const template = $(`<li tabindex="0" ${dataHtml} data-value="${value}"><span class="text">${html}</span></li>`);
                    multiple_template.find('ul.items').append(template);
                });

                multiple_template.find('ul.items li').on('click', function (e) {
                    multiple_template.find('.select_parent').html($(this).find('span.text').html());
                    options.onSelect($(this).data());
                });
            },
            clearSelection() {
                specialSelectElem.find('.select_parent').html(place_holder);
            },
            toggleItems(dataKey, dataValue) {
                specialSelectElem.find('ul.items').show();
                specialSelectElem.find('ul.items li').each(function (index, item) {
                    if ($(item).data(dataKey) !== dataValue) {
                        $(item).hide();
                    } else {
                        $(item).show();
                    }
                });
            },
            hideSelections() {
                specialSelectElem.find('ul.items').hide();
                specialSelectElem.find('ul.items li').hide();
            },
            hideElement() {
                specialSelectElem.hide();
            },
            showElement() {
                specialSelectElem.show();
            }
        };
    };

}( jQuery ));